import { AuthPlatform } from './auth.types';
import { cognitoAuthenticationProvider } from './cognitoAuthentication';
import { zidAuthenticationProvider } from './zidAuthentication';

export const getAuthProviderByType = (provider: AuthPlatform) => {
  if (provider === AuthPlatform.ZID) {
    return zidAuthenticationProvider;
  }

  return cognitoAuthenticationProvider;
};
